angular.module('rjmNg.constants').constant('colorThemeConstants'
  THEMES: Object.freeze
    "0": [
      "#5F90A0"
      "#E89645"
      "#86A644"
      "#E77660"
      "#E0CC0E"
      "#996798"
      "#55AAA0"
      "#66513A"
      "#FBC5FF"
      "#6D3333"
      "#4572A7"
      "#DF5353"
      "#3E4D2B"
      "#F1C900"
      "#FF0066"
      "#266B15"
      "#55BF3B"
      "#5F0CDB"
      "#7798BF"
      "#AAEEEE"
    ]
    "1": [
      "#008EE6"
      "#0CE3F2"
      "#36D65E"
      "#FCD226"
      "#FF8B38"
      "#F255AB"
      "#8849E6"
      "#F24F4F"
      "#4751E0"
      "#2FD6B4"
      "#005E99"
      "#008F99"
      "#009926"
      "#BF9900"
      "#CC5500"
      "#990054"
      "#3D0099"
      "#BA3232"
      "#0B0087"
      "#1E8973"
    ]
    "2": [
      "#082900"
      "#3E885B"
      "#10494C"
      "#3F1313"
      "#162235"
      "#683218"
      "#5B534A"
      "#677C63"
      "#72A887"
      "#84ADB0"
      "#8C7171"
      "#858B95"
      "#B89F94"
      "#A4A4A4"
      "#344F2E"
      "#3F7F83"
      "#613D3D"
      "#404A59"
      "#9E7C6C"
      "#828282"
    ]
    "3": [
      "#EE6352"
      "#255F85"
      "#3E885B"
      "#FFC857"
      "#81739D"
      "#F5A9A0"
      "#C12A0F"
      "#8A6F73"
      "#112C3D"
      "#84B396"
      "#8C6E30"
      "#18004C"
      "#481D24"
      "#AE493C"
      "#9BB6C7"
      "#173222"
      "#D1A448"
      "#B9AFCE"
      "#BCACAF"
      "#301411"
    ]

  THEME_NAMES: Object.freeze
    "0": "Default"
    "1": "Adobe Commerce Intelligence Bright"
    "2": "Adobe Commerce Intelligence Moody"
    "3": "Adobe Commerce Intelligence Sunset"
)